import {PROPERTY_TYPES} from "@/constants";
import Select from "@/components/fields/Select";
import {useAppState} from "@/store";

export default function PropertyType({stateKey}) {

    const {state, setState} = useAppState()

    const handleChange = (v) => {
        setState((s) => {
            s[stateKey] = {
                propertyType: v,
                address: s[stateKey].address,
                street: s[stateKey].street,
                normalizedStreetAddress: s[stateKey].normalizedStreetAddress,
                longitude: s[stateKey].longitude,
                latitude: s[stateKey].latitude,
                city: s[stateKey].city,
                state: s[stateKey].state,
                zip: s[stateKey].zip,
                elevator: false,
                stairs: false
            }
        })
    }

    return (
        <Select
            label={"Property Type"}
            name={`${stateKey}.propertyType`}
            options={PROPERTY_TYPES.map(type => ({value: type.toLowerCase().replace(' ', '_'), label: type}))}
            value={state[stateKey]?.propertyType}
            placeholder={"-- Select Property Type --"}
            onChange={handleChange}
            required
        />
    )
}
